import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(theme => ({
  container: {
    marginTop: -40
  }
}))

export default useStyles
